// extracted by mini-css-extract-plugin
module.exports = {"container":"Summary_container__Q_zcn","column":"Summary_column__124T9","sectionHeading":"Summary_sectionHeading__1dUBZ"};